export const environment = {
  production: false,
  baseUrl: 'https://qa.api.workflow.space',
  workflow: 'https://qa.workflow.space',
  cookiebot: '3d219cc5-eb6f-4e9c-841b-3a9dc3df95da',
  gmt: 'G-MZ5YXKMRCY',
  googleOidcClientId: '852566226006-0sg8a3b91u0hc3trs8lpa7mnsrskhv4u.apps.googleusercontent.com'
};
